import { FORGE_UI_URL } from "../constants/constants";
import { DateTime, Duration } from 'luxon';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

export const DATE_TIME_FORMAT_WITH_SECONDS = DateTime.DATETIME_MED_WITH_SECONDS;

export function uuidToBase64Url(uuid) {
  const hex = uuid.replace(/-/g, "");
  const bytes = new Uint8Array(
    hex.match(/.{1,2}/g).map((b) => parseInt(b, 16))
  );
  let binary = "";
  bytes.forEach((b) => (binary += String.fromCharCode(b)));
  let base64 = btoa(binary);
  return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

export function base64UrlToUuid(base64Url) {
  if (!base64Url) return null;
  let base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  while (base64.length % 4) base64 += "=";

  const binary = atob(base64);
  const bytes = [];
  for (let i = 0; i < binary.length; i++) {
    bytes.push(binary.charCodeAt(i).toString(16).padStart(2, "0"));
  }

  const hex = bytes.join("");
  return [
    hex.substring(0, 8),
    hex.substring(8, 12),
    hex.substring(12, 16),
    hex.substring(16, 20),
    hex.substring(20),
  ].join("-");
}

export function logoutCallback() {
  const payload = {
    redirectForAuth: true,
    redirectUrl: window.location.origin,
  };

  const redirectKey = "redirectFromStandalone";

  let forgeOrigin;
  try {
    forgeOrigin = new URL(FORGE_UI_URL).origin;
  } catch (err) {
    console.error("Invalid FORGE_UI_URL:", FORGE_UI_URL, err);
    return;
  }

  const newTab = window.open(FORGE_UI_URL, "_blank");
  if (newTab) {
    newTab.name = JSON.stringify(payload);
    try {
      newTab.focus?.();
    } catch (e) {
      console.warn("Unable to focus the new tab:", e);
    }
  } else {
    alert(
      "To continue logging in, please enable popups for this site."
    );
    return;
  }

  const onMessage = (event) => {
    if (event.origin !== forgeOrigin) return;

    if (event.source !== newTab) return;
    window.location.reload();
  };

  window.addEventListener("message", onMessage, { once: true });

  const CLEANUP_TIMEOUT_MS = 5 * 60 * 1000;
  const cleanupTimer = setTimeout(() => {
    window.removeEventListener("message", onMessage);
  }, CLEANUP_TIMEOUT_MS);

  const clearTimerOnAnyReply = (event) => {
    if (event.origin === forgeOrigin && event.source === newTab) {
      clearTimeout(cleanupTimer);
      window.removeEventListener("message", clearTimerOnAnyReply);
    }
  };
  window.addEventListener("message", clearTimerOnAnyReply, { once: true });
}
